import {wrapTags} from './wrap-tags';
import {parseBlockTags} from './parse-block-tags';
import {ParseResult} from './markdown';
import {wrapTable, TableOptions} from './wrap-table';

export function parseTree(content: ParseResult[], table: TableOptions = {}) {
	let result: ParseResult[] = [];
	content.forEach((item) => {
		if (item.children) {
			// у таблицы в теге может не быть шапки: `[table headless]` — все строки идут телом
			const options = item.tag === 'tableFigure' ? {headless: item.props?.headless === 'true'} : table;
			const childResult = parseTree(item.children, options);
			if (item.tag === 'TextNode') {
				result = [...result, ...childResult];
			} else {
				// атрибуты тега нужны дальше при отрисовке: `[quote source="…"]`
				result.push({tag: item.tag, children: childResult, props: item.props});
			}
			// пустая строка между блоками — это разделитель, а не абзац: иначе между ними зияет пустой <p>
		} else if (item.content?.trim()) {
			const lines = item.content.trim().split('\n');
			result = [...result, ...wrapTags(wrapTable(lines.map((line) => parseBlockTags(line)), table))];
		} else if (item.tag !== 'TextNode') {
			// тег без содержимого — `[img … /]`: он сам и есть блок
			result.push({tag: item.tag, props: item.props});
		}
	});
	return groupImages(result);
}

/** картинки подряд встают в ряд: по одной они уходят в поля, а пара в колонку уже не помещается */
function groupImages(items: ParseResult[]): ParseResult[] {
	const result: ParseResult[] = [];
	let row: ParseResult[] = [];
	const flush = () => {
		if (row.length > 1) {
			result.push({tag: 'imageRow', children: row.map((image) => ({...image, props: {...image.props, inRow: 'true'}}))});
		} else result.push(...row);
		row = [];
	};
	for (const item of items) {
		if (item.tag === 'bookImage') row.push(item);
		else {
			flush();
			result.push(item);
		}
	}
	flush();
	return result;
}
